export default {
  root: {
    fontWeight: 'bold',
    textTransform: 'unset'
  }
};
